import { ThemeUIStyleObject } from '@chocoapp/chocolate-ui';

export const emojiStyles: ThemeUIStyleObject = {
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '36px',
  height: '36px',
  width: '36px',
};
